import React, { FunctionComponent } from 'react';
import { faCloudSun } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconWeather: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faCloudSun} />;

export { BrassIconWeather };
